var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import { useEffect } from 'react';
import { EditView, EditContextProvider } from 'react-admin';
import { useParams } from 'react-router-dom';
import { useEditNodeController } from './controllers/useEditNodeController';
import NodeEditActions from './NodeEditActions';
import { useExpandedKeys } from './util';
/**
 * Alternative to <Edit> for tree nodes.
 *
 * Adds a button to add a child node in view actions.
 */
var EditNode = function (props) {
    var idProp = props.id;
    var routeId = useParams().id;
    var id = idProp || decodeURIComponent(routeId);
    var _a = useExpandedKeys(), setExpandedKeys = _a[1];
    // Automatically expand the node on mount
    useEffect(function () {
        setExpandedKeys(function (expandedKeys) {
            var key = id.toString();
            if (Array.isArray(expandedKeys)) {
                if (!expandedKeys.includes(key)) {
                    return __spreadArray(__spreadArray([], expandedKeys, true), [key], false);
                }
                return expandedKeys;
            }
            return [key];
        });
    }, [props.resource, id, setExpandedKeys]);
    var controllerProps = useEditNodeController(props);
    return (React.createElement(EditContextProvider, { value: controllerProps },
        React.createElement(EditView, __assign({ actions: defaultActions }, props))));
};
var defaultActions = React.createElement(NodeEditActions, null);
export default EditNode;
